import React, { Fragment } from 'react';

import styled, { css } from 'styled-components';

import { replaceWhitespacesWithHyphen } from '@shared/utils/strings';
import { DefaultWidgetBorder } from '../styles/BordersStyle';
import { MobileScreen } from '../styles/ConstantMediaQuery';
import textStyle from '../styles/texts/textStyle';

import ColorConstants from '../../constants/ColorConstants';

const defaultProps = {
    children: null,
    error: false,
    errorMessage: null,
    label: '',
    labelStyle: {},
    styles: {},
    onClick: null,
    testId: null,
    spanTitle: '',
};

const renderByTypeofProp = (prop) => {
    if (typeof prop === 'function') return prop();
    return prop;
};

const getAutoTestId = (label) => {
    const autoTestIdPrefix = 'accordion-subitem-label-auto-testid-';
    if (typeof label === 'string') {
        return `${autoTestIdPrefix}${replaceWhitespacesWithHyphen(label)}`;
    }
    return `${autoTestIdPrefix}${replaceWhitespacesWithHyphen(label?.props?.subItem?.label || '')}`;
};

const RoundedSquareWithLabel = ({
/* eslint-disable react/prop-types */
    children,
    error,
    errorMessage,
    label,
    labelStyle,
    styles,
    onClick,
    testId,
    spanTitle,
/* eslint-disable react/prop-types */
}) => (
    <Fragment>
        <Wrapper
            data-testid={testId}
            error={error}
            styles={styles}
            onClick={onClick}
        >
            <Label
                error={error}
                title={spanTitle}
                labelStyle={labelStyle}
                data-auto-testid={getAutoTestId(label)}
            >
                {renderByTypeofProp(label)}
            </Label>
            {children}
        </Wrapper>
        {error && errorMessage && <ErrorMessage>{`* ${errorMessage}`}</ErrorMessage>}
    </Fragment>
);

RoundedSquareWithLabel.defaultProps = defaultProps;

const ErrorMessage = styled.span`
    color: ${ColorConstants.salmon};
    font-size: 12px;
    font-weight: 400;
    position: relative;
    top: -5px;
`;

const Label = styled.span`
    ${textStyle};
    font-size: 12px;
    color: ${ColorConstants['light-slate-gray']};
    position: absolute;
    right: 15px;
    text-align: right;
    ${({ labelStyle }) => labelStyle && { ...labelStyle }};
    ${({ error }) => error && css`
        color: ${ColorConstants.salmon};
    `};
`;

const Wrapper = styled.div`
    align-items: center;
    color: ${ColorConstants['violent-violet']};
    display: flex;
    font-weight: 400;
    justify-content: center;
    padding: 0 15px;
    min-height: 50px;
    position: relative;
    ${DefaultWidgetBorder};
    ${({ styles }) => styles && { ...styles }};
    ${({ error }) => error && css`
        border-color: ${ColorConstants.salmon};
    `};
    ${({ onClick }) => onClick && css`
        cursor: pointer;
    `};
    @media ${MobileScreen} {
        justify-content: flex-start;
        padding-left: 10px;
    }
`;

export default RoundedSquareWithLabel;
